import React, {Component} from 'react'
import {Button, Pagination} from 'antd'
import {Link} from "react-router-dom"
import queryString from "qs"
import {_convertObject} from "../../../helpers/convertObject"
import BatchesTable from './table/BatchesTable'
import BatchesFilters from './filters/BatchesFilters'
import {listBatchesV4, exportBatchItems, exportBatchs, exportBatchItemQuantity, getListMaterial, exportSewingGroups, exportBatchsEmbroidery, exportBatchsEmbroideryDetails} from "../../../services/api/3dApi"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { createJobExport } from '../../../helpers/createJobExport'
import { getListBrand } from '../../../services/api/3dApi'
import moment from 'moment'

class BatchesPage extends Component {
    state = {
        batches: [],
        total: 0,
        limit: 50,
        page: 1,
        loading: false,
        error: '',
        filters: {
            name: '',
            partner: [],
            sewing_partner: '',
            mutiple_sewing_partner: [],
            level: '',
            overTimeIn: '',
            overTimeEp: '',
            product_types: [],
            user_create: '',
            status: '',
            batch_overtime: [],
            mex: '',
            sewed : 'all',
            delivered: '',
            note:'',
            printed_qr: '',
            production_partner: [],
        },
        listBrand: [],
        listMaterials: [],
        total_items_without_moved: 0,
        isShowSewingPartner : false
    }

    componentDidMount() {
        const {typeOverTime, status} = this.props
        const timeDefault = moment().subtract(14, 'days').startOf("day").format("DD/MM/YYYY HH:mm")
        const objOvertime = typeOverTime !== undefined && this._convertOvevetime(typeOverTime)
        this._getListBrand()
        this._fetchListMaterials()
        this.setState(({filters}) => {
            if(timeDefault) {
                filters.created_at = {
                    from: timeDefault, to: '',
                    date: { from: timeDefault.split(' ')[0], to: '' },
                    time: { from: timeDefault.split(' ')[1], to: '' }
                }
            }

            return {
                filters: {
                    ...filters,
                    ...objOvertime,
                    status: status ? status : ''
                },
                page: 1
            }
        }, this._fetchBatches)
    }

    _convertOvevetime = (field) => {
        return {
            [field]: {from: 0, phase_status: "not_completed"},
        }
    }

    _fetchListMaterials = async () => {
        try {

            const { data: res } = await getListMaterial({ limit: 10000 })
            const { data, success, message } = res
            if (!success) {
                return this.setState({
                    error : message
                })
            }

            this.setState({
                listMaterials: data.data || []
            })
        } catch (error) {
            this.setState({
                error : error.message
            })
        }
    }

    _fetchBatches = async () => {
        const {requestCount} = this.state
        const nextCount = requestCount ? requestCount + 1 : 1

        this.setState({
            loading: true,
            requestCount: nextCount
        })

        try {
            const {limit, page, filters, listMaterials} = this.state
            const {without_sewing_group = false, without_sewing_partner = false, production_process, embroidery_batch_statistic, designed_at = {}, name: batchNames = [], ...restFilters} = Object.assign({}, filters)
            let sewing_time = ''
            if (filters.hasOwnProperty('sewing_time_type')) {
                switch (filters.sewing_time_type) {
                    case 'received_1d':
                        sewing_time = {from: 0, to: 24}
                        break
                    case 'received_2d':
                        sewing_time = {from: 24, to: 48}
                        break
                    case 'received_3d':
                        sewing_time = {from: 48, to: 72}
                        break
                    case 'received_4d':
                        sewing_time = {from: 72}
                        break
                    case 'not_received':
                        sewing_time = 'not_received'
                        break
                    default:
                        sewing_time = ''
                }
            }

            let payload = {
                ...restFilters,
                limit,
                sewing_time,
                page: page,
                product_types: restFilters.product_types,
            }
            
            if(!!this._handleGetMaterialCode(restFilters.materials, listMaterials).length) payload.materials = this._handleGetMaterialCode(restFilters.materials, listMaterials)

            if (!!batchNames.length) payload.name = {'$in': batchNames.filter(Boolean)}

            if(!!restFilters && !!restFilters.tags && restFilters.tags.some(i => i === "fba")) {
                payload.tags = [...restFilters.tags, 'FBA']
            }else{
                payload.tags =restFilters.tags
            }

            if(without_sewing_group) payload.without_sewing_group = without_sewing_group
            if(without_sewing_partner) payload.without_sewing_partner =without_sewing_partner
            if(production_process) payload.production_process = production_process
            if(!!production_process){
                if(embroidery_batch_statistic) payload.embroidery_batch_statistic = embroidery_batch_statistic
                if(!!Object.keys(designed_at).length) payload.designed_at = {
                    from: designed_at.from,
                    to: designed_at.to
                }
            }

            const newFilter = _convertObject(payload)

            const {data: response} = await listBatchesV4(newFilter)
            const {data, success, error} = response

            if (nextCount !== this.state.requestCount) {
                return
            }

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
                return
            }

            const {batches, total, total_items_without_moved} = data

            this.setState({
                batches,
                total,
                loading: false,
                error: '',
                total_items_without_moved,
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getListBrand = async() => {
        const payload = {
            limit:10000,
            page:1
        }
        try {
            const {data:Data}= await getListBrand(payload)
            const {data, success, message}= Data
            const Brands= data.Brands.map(i=>({value:i.name, label:i.name}))
            if(success){
                this.setState({...this.state, listBrand:Brands})
            }else{
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    _handleChangeInput = (field, value) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: value
                },
                page: 1
            }
        }, this._fetchBatches)
    }

    _handleChangeInputNew = (filter) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    ...filter
                },
                page: 1
            }
        }, this._fetchBatches)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchBatches)
    }

    _handleChangeProductType = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                product_types: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeMaterials = (value) => {
        const {filters} = this.state
            this.setState({
                filters: {
                    ...filters,
                    materials: value
                },
                page: 1
            }, this._fetchBatches)
    }

    _handleChangeDate = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1,
        }, this._fetchBatches)
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page,
        }, this._fetchBatches)
    }

    _handleChangeDelivered = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                delivered: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangePartner = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                partner: value
            },
            page: 1,
        }, this._fetchBatches)
    }

    _handleChangeCheckBox = (checked) => {
        this.setState({
            isShowSewingPartner : !checked
        })
    }

    _handleGetMaterialCode = (material = [], listMaterial = []) => {
        if(!material.length || !listMaterial.length) return []

        let arrMaterial = []
        if(!!material && Array.isArray(material) && material.length){
            material.forEach(item => {
                const material = listMaterial.find(i => i.name === item) || {}
                const code = !!material.code ? material.code : ''
                arrMaterial.push(`${code} - ${item}`)
            })

            arrMaterial.push(...material)
        }else{
            arrMaterial.push(material)
        }

        return arrMaterial
    }

    _handleExport = async (action) => {
        try {
            const {filters, listMaterials} = this.state
            const {embroidery_batch_statistic, designed_at = {}, production_process, name: batchNames = [], ...restFilters} = Object.assign({}, filters)
            let payload = Object.assign({}, restFilters)

            if (!!batchNames.length) payload.name = { '$in': batchNames.filter(Boolean)}

            if (!!this._handleGetMaterialCode(filters.materials, listMaterials).length) payload.materials = this._handleGetMaterialCode(filters.materials, listMaterials)

            if (!!production_process) {
                payload.production_process = production_process
                if (embroidery_batch_statistic) payload.embroidery_batch_statistic = embroidery_batch_statistic
                if (!!Object.keys(designed_at).length) payload.designed_at = {
                    from: designed_at.from,
                    to: designed_at.to
                }
            }
            if (['all-item-batch'].includes(action)) {
                await delete payload.without_sewing_group
                await delete payload.without_sewing_partner
                const { without_sewing_group = false, without_sewing_partner = false } = Object.assign({}, filters)
                let sewing_time = ''
                if (filters.hasOwnProperty('sewing_time_type')) {
                    switch (filters.sewing_time_type) {
                        case 'received_1d':
                            sewing_time = { from: 0, to: 24 }
                            break
                        case 'received_2d':
                            sewing_time = { from: 24, to: 48 }
                            break
                        case 'received_3d':
                            sewing_time = { from: 48, to: 72 }
                            break
                        case 'received_4d':
                            sewing_time = { from: 72 }
                            break
                        case 'not_received':
                            sewing_time = 'not_received'
                            break
                        default:
                            sewing_time = ''
                    }
                }
                payload.sewing_time = sewing_time
                payload.product_types = restFilters.product_types
                if (Array.isArray(batchNames) && batchNames.every(i => !!i)) payload.name = { '$in': batchNames }

                if (!!restFilters && !!restFilters.tags && restFilters.tags.some(i => i === "fba")) {
                    payload.tags = [...restFilters.tags, 'FBA']
                } else {
                    payload.tags = restFilters.tags
                }
                if (without_sewing_group) payload.without_sewing_group = without_sewing_group
                if (without_sewing_partner) payload.without_sewing_partner = without_sewing_partner
            }

            const newFilter = _convertObject(payload)
            const usesBody = ['all-item-batch', 'batch-embroidery-details'].includes(action)
            const query = usesBody ? newFilter : queryString.stringify(newFilter)

            const actionsMap = {
                'all-item-batch': exportBatchItems,
                'batch': exportBatchs,
                'batch-quantity': exportBatchItemQuantity,
                'batch-sewing-group': exportSewingGroups,
                'batch-embroidery': exportBatchsEmbroidery,
                'batch-embroidery-details': exportBatchsEmbroideryDetails,
            }

            const handler = actionsMap[action]
            const {data: response} = await handler(query)

            if (typeof response !== 'string') {
                const { success, message: mess, data } = response || {}

                if (!success) throw new Error(mess)

                if (!data || Object.keys(data).length === 0) {
                    throw new Error('Không nhận được thông tin job từ server')
                }
                createJobExport(data)
            } else {
              if (response) downloadFileFromData(response, { filename: `${action}${moment().format('HH_mm_DD_MM_YYYY')}.csv` })
            }

        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const {batches, error, page, total, limit, loading, filters, status, listBrand, total_items_without_moved, listMaterials, isShowSewingPartner = false} = this.state
        const newBatches = isShowSewingPartner ? batches.filter(i => {
            const {sewing_partner = {}} = Object.assign({}, i)
            const {has_groups = false} = Object.assign({}, sewing_partner)
            return !!has_groups
        }) : batches
        const newFilter = _convertObject({...filters, materials: this._handleGetMaterialCode(filters.materials, listMaterials)})
        const notMovedTotal = !!total_items_without_moved ? (total_items_without_moved > 1 ? `(${total_items_without_moved} items)` : `(${total_items_without_moved} item)`) : '' 

        return (
            <div className='LabelPage BatchesPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="mt-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3 className='m-0'>Danh sách Lô </h3>
                                <div>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/batch-reproduction"
                                    >
                                        Lỗi QC sau ép
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/item-reproduction"
                                    >
                                        Lỗi QC hoàn thành
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/item-piece-error"
                                    >
                                        Item bù chi tiết
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/color-system-error"
                                    >
                                        Lỗi hệ màu
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary ${(total > 5000 || loading || total === 0) ? 'disabled' : ''}`}
                                        to={{
                                            pathname: "/static-batches",
                                            search: queryString.stringify(newFilter),
                                        }}
                                    >
                                        Xem chi tiết
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/items-error"
                                    >
                                        Items lỗi
                                    </Link>
                                    <Button type="primary" onClick={() => this._handleExport('all-item-batch')} className='mr-3'>
                                        Export item
                                    </Button>
                                    <Button type="primary" onClick={() => this._handleExport('batch')} className='mr-3'>
                                        Export lô
                                    </Button>
                                    <Button type="primary" onClick={() => this._handleExport('batch-quantity')} className='mr-3'>
                                        Export số lượng item
                                    </Button>
                                    <Button type="primary" onClick={() => this._handleExport('batch-sewing-group')} className='mr-3'>
                                        Export nhóm may
                                    </Button>
                                    <Button type="primary" onClick={() => this._handleExport('batch-embroidery')}>
                                        Export sản lượng thêu
                                    </Button>
                                    {!!filters.production_process && (
                                        <Button type="primary" onClick={() => this._handleExport('batch-embroidery-details')} className='ml-3'>
                                            Chi tiết lô thêu
                                        </Button>
                                    )}
                                </div>
                            </div>

                            <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                                <BatchesFilters
                                    filters={filters}
                                    loading={loading}
                                    listBrand={listBrand}
                                    listMaterials={listMaterials}
                                    handleChangeInput={this._handleChangeInput}
                                    handleChangeDate={this._handleChangeDate}
                                    onChangeProductType={this._handleChangeProductType}
                                    onChangeMaterials={this._handleChangeMaterials}
                                    onChangeInputNew={this._handleChangeInputNew}
                                    isShowSewingPartner={isShowSewingPartner}
                                    onChangeCheckBox={this._handleChangeCheckBox}
                                    {...this.props}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                                <div>
                                    {error && (
                                        <div className="text-danger mb-2">{error}</div>
                                    )}
                                </div>
                                <Pagination current={page} total={total} pageSize={limit}
                                            showTotal={(sum, range) => sum > 0 &&
                                                <div>
                                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}
                                                    <strong>
                                                        {`${total} lô hàng ${notMovedTotal}`}
                                                    </strong>
                                                </div>}
                                            onChange={this._handlePageChange}
                                            className='text-right' showSizeChanger
                                            pageSizeOptions={['10', '20', '50', '100', '200']}
                                            onShowSizeChange={this._handleShowSizeChange}/>
                            </div>
                            <div className="BatchesTable">
                                <BatchesTable
                                    status={status}
                                    batches={newBatches}
                                    loading={loading}
                                    refreshBatches={this._fetchBatches}
                                    onChangeProductType={this._handleChangeProductType}
                                    onChangeMaterials={this._handleChangeMaterials}
                                    handleChangeInput={this._handleChangeInput}
                                    filters={newFilter}
                                />
                            </div>
                            <Pagination
                                current={page} total={total} pageSize={limit}
                                onChange={this._handlePageChange}
                                showQuickJumper
                                className='CustomPagination text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100','200']}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default BatchesPage
